// extracted by mini-css-extract-plugin
export var footer = "_q7-0";
export var inherit = "_q7-1";
export var input = "_q7-2";
export var modalContent = "_q7-3";
export var quillEditor = "_q7-4";
export var subtitle = "_q7-5";